import { render, staticRenderFns } from "./quota-table.vue?vue&type=template&id=54ebc2d2&lang=pug&"
import script from "./quota-table.vue?vue&type=script&lang=js&"
export * from "./quota-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports